module.exports = __webpack_public_path__ + "img/0.1fd4a562.jpg";